/**
 *    UTILITY FUNCTIONS
 *    app-wide utility methods
 *
 *    note: there are some duplicated methods in this class from other services
 *    utility cannot depend on other services since most other services depend on utility
 *    (avoiding circular references)
 */

import {
    Affiliate,
    AffiliateAccount,
    DroplistItem,
    LoginResponse,
    UserPreferences,
    HttpErrorIgnore,
    UserInfo,
} from '../../global';
import { TblFltOption } from './table/table.types';

const utilSvc = {
    str: {
        isText: isText,
        toText: toText,
    },
    array: {
        sortASC: sortAscending,
        sortTextASC: sortTextAscending,
        sortDSC: sortDescending,
        sortTextDSC: sortTextDescending,
    },
    aff: {
        findStatus: affFindStatus,
        findStatusOfCe: affFindStatusOfCE,
        findCe: affFindCe,
        findCeList: affFindCeList,
        findRx: affFindRx,
        findRxList: affFindRxList,
        findRxType: affFindRxType,
        findRxModel: affFindRxModel,
        findRxBilling: affFindRxBilling,
        findVen: affFindVen,
        findVenType: affFindVenType,
        findShareGroup: affFindShareGroup,
        findWithVendor: affWithVendor,
        findVerityAdmin: affFindVerityAdmin,
        findProgramAdmin: affProgramAdmin,
        findProgramAdminList: affProgAdminList,
        ceList: affCeList,
        rxList: affRxList,
        ceDroplist: affCeDroplist,
        ceDroplistLabel: affCeDroplistLabel,
        rxDroplist: affRxDroplist,
        venList: affVenList,
        shareGroupList: affShareGroupList,
        rxModelList: affRxModelList,
        rxModelsByFeature: affRxModelsByFeature,
        rxShortNameById: rxShortNameById,
        ceOptions: affCeOptions,
        rxOptions: affRxOptions,
        rxOptionsByTPA: affRxOptionsByTPA,
        venOptions: affVenOptions,
        accumGrpAllOptions: affAccumGrpAllOptions,
        droplistByType: droplistByType,
        tpaDroplist: tpaDroplist,
    },
    ng: {
        droplist: ngDroplist,
    },
    http: {
        safeResponse: httpSafeResponse,
        isIgnore: httpIsIgnore,
        ignore: httpIgnore,
        apiContextToAllArray: apiContextToAllArray,
    },
    user: {
        hasFeature: userHasFeature,
        parseLoginProfile: userParseLoginProfile,
    },
    regex: {
        // loginPwd: regexLogin,
        // dateFmt: regexDateFmt,
        // apiDateStringFmt: regexApiDateStringFmt,
        // apiDateTimeStringFmt: regexApiDateTimeStringFmt,
        cleanFilename: regexFilename,
        // alpha: regexAlpha
    },
    dt: {
        isValid: dateValid,
        isNull: dateIsNull,
        parse: dateParse,
        zeroTime: dateZeroTime,
        addDays: dateAddDays,
        diffMilli: dateDiffMilli,
        cleanJson: dateCleanJson,
        toText: dateToText,
        toTextUTC: dateToTextUTC,
        toTextWithTime: dateToTextWithTime,
        toServerDate: dateServerDate,
        toServerString: dateServerString,
        toServerDateExactUTC: dateServerDateExactUTC,
        toIsoDate,
        monthShortText: dateMonthShortText,
        monthFullText: dateMonthFullText,
        monthStart: dateMonthStart,
        monthEnd: dateMonthEnd,
        quarterStart: dateQuarterStart,
        parseLocalDate: parseLocalDate,
        secondsFmt: secondsFmt,
        fmtMdyyyy: 'M/d/yyyy',
        fmtMdyyyyhmmssa: 'M/d/yyyy h:mm:ss a',
    },
    loc: {
        stateNames: locStateNames,
    },
    num: {
        parse: numParse,
        formatWithComma: formatNumberWithComma,
    },
};

/*	
	var util = {
		num: {
			randomInt: randomInt,
			parse: numParse,
			toDayTextShort: numDayShortText,
			numberFmt: numberFmt
		},
		dt: {
			isValid: dateValid,
			isNull: dateIsNull,
			zeroTime: dateZeroTime,
			addDays: dateAddDays,
			addMonths: dateAddMonths,
			monthStart: dateMonthStart,
			monthEnd: dateMonthEnd,
			quarterStart: dateQuarterStart,
			utcOffset: dateUtcOffset,
			diffMilli: dateDiffMilli,
			diffSeconds: dateDiffSeconds,
			diffMinutes: dateDiffMinutes,
			diffDays: dateDiffDays,
			greaterThan: dateGreaterThan,
			lessThan: dateLessThan,
			toServerDateExactPSTNoon: dateServerDateExactPSTNoon,
			
			fromServerDateExactPST: dateParseServerDateExactPST,
			fromServerDateExactUTC: dateParseServerDateExactUTC,
			fromServerString: dateParseServerString,
			
			dayFullText: dateDayFullText,
			dateModeText: dateModeText,
			dateModeKeepDates: dateModeKeepDates
		},
		ctl: {
			addSorting: addSorting,
			addPaging: addPaging,
			addFiltering: addFiltering,
			addMultiselect: addMultiselect,
			addFlexTop: addFlexTop,
			addTableViews: addTableViews
		},
		http: {
			safeResponse: httpSafeResponse
		},
		paging: {
			addMethods: addPaging,
			getTotalPages: getTotalPages,
			apiResults: apiResultsPaging
		},
		sorting: {
			addMethods: addSorting,
			sortByViewStyle: sortByViewStyle,
			sortByApiStyle: sortByApiStyle
		},
		ng: {
			droplist: ngDroplist,
			droplistNONE: ngDroplistNONE,
			droplistALL: ngDroplistALL,
			droplistAutoselect: ngDroplistAutoselect,
			droplistLabel: ngDroplistLabel,
			stateFullNamesDroplist: ngStateFullNamesDroplist,
			stateShortNamesDroplist: ngStateShortNamesDroplist,
			monthShortDroplist: ngMonthShortDroplist,
			monthFullDroplist: ngMonthFullDroplist
		},
		css: {
			btnStyle: cssButtonStyle,
			validStyle: cssValidStyle
		},
		json: {
			stringify: jsonStringify,
			stringifyPretty: jsonStringifyPretty,
			parse: jsonParse
		},
		obj: {
			findChildProp: objFindChildProp
		},
		widget: {
			dateRangeList: widDateRangeList
		},
		user: {
			hasFeature: userHasFeature,
			parseLoginProfile: userParseLoginProfile
		},
		tblview: {
			initViews: tblViewInit
		}
	};

	return util;


	/**
	 *    STRING
	 */

function isText(testVal: any): boolean {
    if (!!!testVal || typeof testVal !== 'string' || testVal.trim() === '') {
        return false;
    } else {
        return true;
    }
}

function toText(testVal: any): string {
    if (testVal === null || typeof testVal === 'undefined') {
        return '';
    }

    if (typeof testVal == 'string') {
        return testVal;
    }

    let result = '';
    try {
        result = testVal.toString();
        return result;
    } catch (err) {
        // do nothing
    }

    return '';
}

// 	/**
// 	 *    NUMBER
// 	 */

function numParse(numText: any): number {
    // convert a non-number to a valid number or zero

    // already a number
    if (typeof numText === 'number') {
        return numText;
    }

    // convert anything else to a string
    const newText = toText(numText);

    // is negative, leading '-' or enclosed in '()'
    const isNeg = newText.substr(0, 1) === '-' || (newText.substr(0, 1) === '(' && newText.substr(-1, 1) === ')');

    // regex for numbers and decimal
    const finalText = newText.replace(/[^0-9.]+/g, '');

    // parse to float
    try {
        const newNum = parseFloat(finalText);
        if (!!!newNum) {
            return 0;
        } else {
            return newNum * (isNeg ? -1 : 1);
        }
    } catch (err) {
        return 0;
    }
}

// Convert numbers to comma-separated strings, handle null/undefined gracefully
function formatNumberWithComma(val: any): string {
    if (val === null || val === undefined || val === '') return '';
    if (typeof val === 'number') return val.toLocaleString();
    if (typeof val === 'string') {
        // Remove commas and whitespace, then parse
        const num = Number(val.replace(/,/g, '').trim());
        return isNaN(num) ? val : num.toLocaleString();
    }
    return '';
}

/*
// 	function randomInt(min, max) {
// 		return Math.floor(Math.random() * (max - min)) + min;
// 	}


	/**
	 *    DATE
	 *    borrowed a few functions from moment.js
	 *    its overkill to include the whole thing
	 */

function dateIsNull(dt: any): boolean {
    // check for both JavaScript and api server null date values

    if (!!!dt || dt === null) {
        return true;
    }

    // server null date string
    if (typeof dt === 'string' && (dt === '0001-01-01T00:00:00Z' || dt === '0001-01-01')) {
        return true;
    }

    return false;
}

function dateCleanJson(dt: any): string {
    // clean up JSON dates sent by server, if null or not JSON format return empty string
    if (typeof dt !== 'string' || dateIsNull(dt)) {
        return '';
    }
    return /^\d{4}-\d{2}-\d{2}T(.*)[Z]$/.test(dt) ? dt : '';
}

function dateServerDate(dt): '0001-01-01T00:00:00Z' | Date {
    const result = dateParse(dt);

    if (!!!result || result === null) {
        return '0001-01-01T00:00:00Z';
    } else {
        return result;
    }
}

function dateServerDateExactUTC(dtExactString): string {
    // convert a user entered string into UTC ISO string with no local offset
    // note: incoming "exact dates" are in a string format "m/d/yyyy", there is no timezone or date object

    let result = '0001-01-01T00:00:00Z'; // api null date is an ISO string

    if (isText(dtExactString)) {
        const dtVals = dtExactString.split('/');
        if (dtVals.length !== 3) {
            return result;
        }

        // create date object, constructor uses now local timezone
        const dt = new Date();

        // reset underlying UTC milliseconds
        // create date in UTC 0
        dt.setTime(Date.UTC(dtVals[2], parseInt(dtVals[0]) - 1, dtVals[1]));

        result = dt.toISOString();
    }

    return result;
}

function dateServerString(uiDate): string {
    // convert date object into api string format: mm-dd-yyyy

    if (!dateValid(uiDate)) {
        return '';
    }

    let dtMonth = (uiDate.getMonth() + 1).toString(),
        dtDay = uiDate.getDate().toString();

    if (dtMonth.length < 2) {
        dtMonth = '0' + dtMonth;
    }
    if (dtDay.length < 2) {
        dtDay = '0' + dtDay;
    }

    return uiDate.getFullYear().toString() + '-' + dtMonth + '-' + dtDay;
}

function dateObjectValid(dt: any): boolean {
    // date type (ala angular source code)
    return !!dt && Object.prototype.toString.call(dt) === '[object Date]' && !isNaN(Date.parse(dt));
}

function dateValid(dt: any): boolean {
    // falsy
    if (!!!dt) {
        return false;
    }

    // already a date object
    if (dateObjectValid(dt)) {
        return true;
    }

    // try parsing: string or number
    if (typeof dt === 'string' || !isNaN(dt)) {
        // server string null date
        if (dateIsNull(dt)) {
            return false;
        }

        try {
            const dtParse = new Date(Date.parse(dt));
            return dateObjectValid(dtParse);
        } catch (err) {
            // do nothing, failed
        }
    }

    // failed to convert
    return false;
}

function dateParse(dt: any): Date | null {
    // same as isDate above, but returns a valid date object

    // falsy
    if (!!!dt) {
        return null;
    }

    // already a date object
    if (dateObjectValid(dt)) {
        return dt;
    }

    // try parsing: string or number
    if (typeof dt === 'string' || !isNaN(dt)) {
        // server string null date
        if (dateIsNull(dt)) {
            return null;
        }

        try {
            const dtParse = new Date(Date.parse(dt));
            if (dateObjectValid(dtParse)) {
                return dtParse;
            }
        } catch (err) {
            // do nothing, failed
        }
    }

    // failed to convert
    return null;
}

// Converts YYYY-MM-DD to ISO string with 08:00:00.000Z, or returns ISO as-is
function toIsoDate(val: string): string {
    if (!val) return '';
    if (val.includes('T')) return val;
    return `${val}T08:00:00.000Z`;
}

function dateZeroTime(dt: Date): Date {
    return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0);
}

function secondsFmt(seconds: number): string {
    if (!seconds || seconds < 1) return '';

    let result = '';

    // weeks
    let div = Math.floor(seconds / 604800);
    if (div > 0) {
        result = div.toString() + ' wks';
        seconds -= div * 604800;
    }

    // days
    div = Math.floor(seconds / 86400);
    if (div > 0) {
        result = (result.length > 0 ? result + ', ' : '') + div.toString() + ' days';
        seconds -= div * 86400;
    }

    const hh = Math.floor((seconds % 86400) / 3600).toString();
    const nn = Math.floor(((seconds % 86400) % 3600) / 60).toString();
    const ss = (((seconds % 86400) % 3600) % 60).toString();

    result = result.length > 0 ? result + ', ' : '';
    result += (hh.length === 1 ? '0' : '') + hh + ':';
    result += (nn.length === 1 ? '0' : '') + nn + ':';
    result += (ss.length === 1 ? '0' : '') + ss;

    return result;
}

function dateAddDays(dt: Date, days: number): Date {
    return new Date(
        dt.getFullYear(),
        dt.getMonth(),
        dt.getDate() + days,
        dt.getMinutes(),
        dt.getSeconds(),
        dt.getMilliseconds(),
    );
}

// 	function dateAddMonths(dt, months) {
// 		return new Date(dt.getFullYear(), dt.getMonth() + months, dt.getDate(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());
// 	}

function dateMonthStart(dt: Date): Date {
    return new Date(dt.getFullYear(), dt.getMonth(), 1, 0, 0, 0);
}

function dateMonthEnd(dt: Date): Date {
    return new Date(dt.getFullYear(), dt.getMonth() + 1, 0, 0, 0, 0);
}

function dateQuarterStart(dt: Date): Date {
    // note: getMonth() returns 0 - 11

    switch (dt.getMonth()) {
        case 0:
        case 1:
        case 2:
            return new Date(dt.getFullYear(), 0, 1, 0, 0, 0);
        case 3:
        case 4:
        case 5:
            return new Date(dt.getFullYear(), 3, 1, 0, 0, 0);
        case 6:
        case 7:
        case 8:
            return new Date(dt.getFullYear(), 6, 1, 0, 0, 0);
        case 9:
        case 10:
        case 11:
        default:
            return new Date(dt.getFullYear(), 9, 1, 0, 0, 0);
    }
}

function dateUtcOffset(dt): any {
    // offset date to account for daylight savings time
    // note: only minutes correctly handles utc offset values, not getTime()
    const offset = new Date(dt);
    offset.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return offset;
}

function dateDiffMilli(start, end): number {
    return dateUtcOffset(end) - dateUtcOffset(start);
}

// 	function dateDiffSeconds(start, end) {
// 		return dateDiffMilli(start, end) / 1000; // 1 second
// 	}

// 	function dateDiffMinutes(start, end) {
// 		return dateDiffMilli(start, end) / 60000; // 1 minute
// 	}

// 	function dateDiffDays(start, end) {
// 		return dateDiffMilli(start, end) / 86400000; // 1 day
// 	}

// 	function dateGreaterThan(initial, comparison, equal) {
// 		if(!!!equal) {
// 			return dateDiffMilli(initial, comparison) > 0;
// 		}
// 		else {
// 			return dateDiffMilli(initial, comparison) >= 0;
// 		}
// 	}

// 	function dateLessThan(initial, comparison, equal) {
// 		if(!!!equal) {
// 			return dateDiffMilli(initial, comparison) < 0;
// 		}
// 		else {
// 			return dateDiffMilli(initial, comparison) <= 0;
// 		}
// 	}

function dateToText(dt): string {
    // default format is: M/d/yyyy
    const dtValid = dateParse(dt);
    if (!!dtValid) {
        return (
            (dtValid.getMonth() + 1).toString() +
            '/' +
            dtValid.getDate().toString() +
            '/' +
            dtValid.getFullYear().toString()
        );
    } else {
        return '';
    }
}

function dateToTextUTC(dt: any): string {
    // default format is: M/d/yyyy
    const dtValid = dateParse(dt);
    if (!!dtValid) {
        return (
            (dtValid.getUTCMonth() + 1).toString() +
            '/' +
            dtValid.getUTCDate().toString() +
            '/' +
            dtValid.getUTCFullYear().toString()
        );
    } else {
        return '';
    }
}

function dateToTextWithTime(dt): string {
    // default format is: M/d/yyyy
    const dtValid = dateParse(dt);
    if (!!dtValid) {
        const dtTxt = dateToText(dtValid),
            txtHours = dtValid.getHours().toString(),
            txtMins = dtValid.getMinutes().toString(),
            txtSec = dtValid.getSeconds().toString();

        return (
            dtTxt +
            ' ' +
            (txtHours.length < 2 ? '0' : '') +
            txtHours +
            ':' +
            (txtMins.length < 2 ? '0' : '') +
            txtMins +
            ':' +
            (txtSec.length < 2 ? '0' : '') +
            txtSec
        );
    } else {
        return '';
    }
}

function dateMonthShortText(dt): string {
    if (dateValid(dt)) {
        return ngMonthShortDroplist()[dt.getMonth()].label;
    } else {
        return 'invalid';
    }
}

function dateMonthFullText(dt): string {
    if (dateValid(dt)) {
        return ngMonthFullDroplist()[dt.getMonth()].label;
    } else {
        return 'invalid';
    }
}

// 	function dateDayFullText(dt) {
// 		if(dateValid(dt)) {
// 			switch(dt.getDay()) {
// 				case 0:
// 					return 'sunday';
// 				case 1:
// 					return 'monday';
// 				case 2:
// 					return 'tuesday';
// 				case 3:
// 					return 'wednesday';
// 				case 4:
// 					return 'thursday';
// 				case 5:
// 					return 'friday';
// 				case 6:
// 					return 'saturday';
// 				default:
// 					throw new Error('utilSvc.dateDayFullText, unknown day of the week: ' + dt.getDay());
// 			}
// 		}
// 		else {
// 			return 'invalid';
// 		}
// 	}

// 	function numDayShortText(num) {
// 		switch(num) {
// 			case 0:
// 				return 'sun';
// 			case 1:
// 				return 'mon';
// 			case 2:
// 				return 'tue';
// 			case 3:
// 				return 'wed';
// 			case 4:
// 				return 'thu';
// 			case 5:
// 				return 'fri';
// 			case 6:
// 				return 'sat';
// 			default:
// 				throw new Error('utilSvc.numDayShortText, unknown day of the week: ' + num);
// 		}
// 	}

// 	function dateModeText(items, dtMode, startDate, endDate) {

// 		// convert any date control mode and droplist option to text

// 		switch(dtMode) {
// 			case 'QTR':
// 				return displayQuarter(startDate);

// 			case 'MONTHLY':
// 				return dateMonthShortText(startDate) + ' ' + startDate.getFullYear().toString();

// 			case 'YEARLY':
// 				return 'Year: ' + startDate.getFullYear().toString();

// 			default:
// 				if(dtMode.indexOf('CUSTOM') > -1) {
// 					return 'Custom Dates: ' + dateToText(startDate) + ' to ' + dateToText(endDate);
// 				}
// 				else {
// 					for(var i = 0; i < items.length; i++) {
// 						if(items[i].value == dtMode) {
// 							return items[i].label;
// 						}
// 					}
// 					return '';
// 				}
// 		}

// 	}

// 	function displayQuarter(dt) {

// 		// return Q1, Q2 text from incoming date

// 		var pdt = dateParse(dt);
// 		if(pdt == null) {
// 			return '';
// 		}

// 		var qtrNum = Math.floor(pdt.getMonth() / 3) + 1;
// 		return 'Q' + qtrNum + ' ' + pdt.getFullYear().toString();

// 	}

// 	function dateModeKeepDates(dtMode) {

// 		// determine if specific dates are needed to restore this date mode for elbow grease etc..

// 		switch(dtMode) {
// 			case 'TODAY':
// 			case 'YESTERDAY':
// 			case 'TODAYYESTERDAY':
// 			case '2DAYS':
// 			case '3DAYS':
// 			case '4DAYS':
// 			case '7DAYS':
// 			case '2WEEKS':
// 			case 'LMTD':
// 			case 'MTD':
// 			case 'LQTD':
// 			case 'QTD':
// 			case 'QTDLAST':
// 			case 'YTD':
// 			case 'LYTD':
// 			case 'LTM':
// 			case 'LLTM':
// 				return false;

// 			case 'QTR':
// 			case 'MONTHLY':
// 			case 'YEARLY':
// 				return true;

// 			default:
// 				if(dtMode.indexOf('CUSTOM') > -1) {
// 					return true;
// 				}
// 				alert('utilSvc.dateModeKeepDates, unknown date mode: ' + dtMode);
// 				return false;
// 		}
// 	}

/**
 *    ARRAY IE SORT FIX
 */

function sortTextDescending(items, propName): any[] {
    return sortDescending(items, propName, 'text');
}

function sortDescending(items, propName, propType): any[] {
    // params
    if (!Array.isArray(items)) {
        return [];
    }

    // sort by property name
    if (typeof propName === 'string' && propName.length > 0) {
        // text sort
        if (propType === 'text') {
            items.sort(function (a, b) {
                // case insensitive
                const aVal = a[propName].toUpperCase(),
                    bVal = b[propName].toUpperCase();

                if (aVal > bVal) {
                    return -1;
                }
                if (aVal < bVal) {
                    return 1;
                }
                return 0;
            });
        } else {
            items.sort(function (a, b) {
                const aVal = a[propName],
                    bVal = b[propName];

                if (aVal > bVal) {
                    return -1;
                }
                if (aVal < bVal) {
                    return 1;
                }
                return 0;
            });
        }
    } else {
        // value sort
        if (propType === 'text') {
            items.sort(function (a, b) {
                // case insensitive
                const aVal = a.toUpperCase(),
                    bVal = b.toUpperCase();

                if (aVal > bVal) {
                    return -1;
                }
                if (aVal < bVal) {
                    return 1;
                }
                return 0;
            });
        } else {
            items.sort(function (a, b) {
                if (a > b) {
                    return -1;
                }
                if (a < b) {
                    return 1;
                }
                return 0;
            });
        }
    }

    return items;
}

function sortTextAscending(items, propName): any[] {
    return sortAscending(items, propName, 'text');
}

function sortAscending(items, propName, propType): any[] {
    // params
    if (!Array.isArray(items)) {
        return [];
    }

    // object sort by property
    if (typeof propName === 'string' && propName.length > 0) {
        // text sort
        if (propType === 'text') {
            items.sort(function (a, b) {
                // case insensitive
                const aVal = a[propName].toUpperCase(),
                    bVal = b[propName].toUpperCase();

                if (aVal < bVal) {
                    return -1;
                }
                if (aVal > bVal) {
                    return 1;
                }
                return 0;
            });
        } else {
            items.sort(function (a, b) {
                const aVal = a[propName],
                    bVal = b[propName];

                if (aVal < bVal) {
                    return -1;
                }
                if (aVal > bVal) {
                    return 1;
                }
                return 0;
            });
        }
    } else {
        // value sort
        if (propType === 'text') {
            items.sort(function (a, b) {
                // case insensitive
                const aVal = a.toUpperCase(),
                    bVal = b.toUpperCase();

                if (aVal < bVal) {
                    return -1;
                }
                if (aVal > bVal) {
                    return 1;
                }
                return 0;
            });
        } else {
            items.sort(function (a, b) {
                if (a < b) {
                    return -1;
                }
                if (a > b) {
                    return 1;
                }
                return 0;
            });
        }
    }

    return items;
}

/**
 *    NG ANGULAR HELPERS
 *    create angular friendly data structures to render in html
 */

function ngDroplist(
    items: string[],
    lblProp?: string,
    valProp?: string,
    addTopItems?: DroplistItem[],
    addBottomItems?: DroplistItem[],
): DroplistItem[] {
    // build a drop down list of items, optionally add top and bottom items

    const droplist: DroplistItem[] = [];
    let i = 0;

    // optional top items
    if (Array.isArray(addTopItems)) {
        for (let itop = 0; itop < addTopItems.length; itop++) {
            droplist.push({
                label: addTopItems[itop].label,
                value: addTopItems[itop].value,
            });
        }
    }

    // label/value dropdown items
    if (Array.isArray(items)) {
        // 1 time check for label/value prop names
        lblProp = isText(lblProp) ? lblProp : '';
        valProp = isText(valProp) ? valProp : '';

        if (!!!lblProp && !!!valProp) {
            // no label prop, no value prop
            for (i = 0; i < items.length; i++) {
                droplist.push({
                    label: items[i],
                    value: items[i],
                });
            }
        } else if (!!lblProp && !!valProp) {
            // has label prop, has value prop
            for (i = 0; i < items.length; i++) {
                droplist.push({
                    label: items[i][lblProp],
                    value: items[i][valProp],
                });
            }
        } else if (!!lblProp && !!!valProp) {
            // has label prop, no value prop
            for (i = 0; i < items.length; i++) {
                droplist.push({
                    label: items[i][lblProp],
                    value: items[i],
                });
            }
        } else if (!!!lblProp && !!valProp) {
            // no label prop, has value prop
            for (i = 0; i < items.length; i++) {
                droplist.push({
                    label: items[i],
                    value: items[i][valProp],
                });
            }
        }
    }

    // optional bottom items
    if (Array.isArray(addBottomItems)) {
        for (let ibot = 0; ibot < addBottomItems.length; ibot++) {
            droplist.push({
                label: addBottomItems[ibot].label,
                value: addBottomItems[ibot].value,
            });
        }
    }

    return droplist;
}

function parseLocalDate(val?: string): Date {
    if (!val) return new Date();
    // Parse YYYY-MM-DD as local midnight
    const parts = val.split('-').map(Number);
    if (parts.length === 3) {
        return new Date(parts[0], parts[1] - 1, parts[2]);
    }
    return new Date(val);
}

// 	function ngDroplistAutoselect(droplist, nickname, noTitleItem) {

// 		// automatically choose a droplist item, return it as a new Property

// 		var minLen = !!noTitleItem ? 1 : 2,
// 			newProp = {
// 				val: 'NONE',
// 				fail: false,
// 				msg: ''
// 			};

// 		// only 1 option in the droplist, select it
// 		// note: first item is always the 'NONE' value
// 		if(droplist.length === minLen) {
// 			newProp.val = droplist[1].value;
// 		}
// 		else if(isText(nickname) && nickname != 'NONE') {

// 			for(var i = 0; i < droplist.length; i++) {
// 				if(droplist[i].value == nickname) {
// 					newProp.val = nickname;
// 					break;
// 				}
// 			}

// 		}

// 		// no auto select available, reset to NONE
// 		return newProp;

// 	}

// 	function ngDroplistLabel(droplist, dropVal) {

// 		// find droplist item by val, return its label text

// 		// params
// 		if(!Array.isArray(droplist) || droplist.length < 1) {
// 			return '';
// 		}

// 		for(var i = 0; i < droplist.length; i++) {
// 			if(droplist[i].value === dropVal) {
// 				return droplist[i].label;
// 			}
// 		}

// 		return '';
// 	}

// 	function ngDroplistNONE() {
// 		return [{label:'', value:'NONE'}];
// 	}

// 	function ngDroplistALL() {
// 		return [{label:'', value:'ALL'}];
// 	}

// 	/**
// 	 *    SORT BY
// 	 *    sorting fields have a property name
// 	 *    note: for descending order, in angualr the field name has a leading '-'
// 	 */

// 	function sortName(sortField) {

// 		// invalid string
// 		if(!isText(sortField)) {
// 			return '';
// 		}
// 		sortField = sortField.trim();

// 		// desc
// 		if(sortField.substr(0,1) == '-') {

// 			// invalid desc string
// 			if(sortField.length < 2) {
// 				return '';
// 			}
// 			else {
// 				return sortField.substr(1);
// 			}
// 		}

// 		// asc
// 		return sortField;

// 	}

// 	function sortOrder(sortField) {

// 		// determines if a field is sorting by ASC, DSC or is invalid (null)

// 		var fieldName = sortName(sortField);

// 		// invalid
// 		if(!isText(fieldName)) {
// 			return '';
// 		}

// 		// descending
// 		if(sortField.substr(0,1) == '-') {
// 			return 'DSC';
// 		}

// 		// ascending
// 		return 'ASC';

// 	}

// 	/**
// 	 *    ADD SORTING
// 	 *    used by controllers to add list sorting support
// 	 */

// 	function addSorting(vm) {
// 		vm.sortBy = sortBy;
// 		vm.sortByIcon = sortByIcon;
// 		vm.sortByViewStyle = sortByViewStyle;
// 		vm.sortByApiStyle = sortByApiStyle;
// 	}

// 	function sortByViewStyle(sortByApiVM) {

// 		// convert from api sort by into view sort by format

// 		if(!!sortByApiVM && isText(sortByApiVM.Field) && isText(sortByApiVM.Order)) {
// 			return sortByApiVM.Order == 'DSC' ? '-' : '' + sortByApiVM.Field;
// 		}
// 		else {
// 			return '';
// 		}

// 	}

// 	function sortByApiStyle(sortByString) {

// 		// convert from view sort by into api sort by format

// 		return {
// 			Field: sortName(sortByString),
// 			Order: sortOrder(sortByString)
// 		};

// 	}

// 	function sortBy(fieldName, display) {

// 		// toggle sorting for a ui column
// 		// if not sorting by this column already, sort ascending by default

// 		// valid field name
// 		if(!isText(fieldName)) {
// 			return;
// 		}
// 		var asc = fieldName,
// 			dsc = '-' + fieldName;

// 		// get current sort
// 		var currentSort = '';
// 		if(Array.isArray(display.SortBy) && display.SortBy.length > 0) {
// 			currentSort = display.SortBy[0];
// 		}

// 		if(currentSort === asc) {
// 			display.SortBy = [dsc];
// 		}
// 		else if(currentSort === dsc) {
// 			display.SortBy = [asc];
// 		}
// 		else {
// 			// no toggle, just set to asc on first click
// 			display.SortBy = [asc];
// 		}

// 		// reset paging to 1 on all column sorts
// 		//display.Paging.Page = 1;

// 	}

// 	function sortByIcon(fieldName, SortBy) {

// 		// returns the CSS icon class for the sort state of this field, values can be:
// 		// 'icon-asc', 'icon-dsc' or '' = not found

// 		// valid field name
// 		if(!isText(fieldName) || !Array.isArray(SortBy) || SortBy.length < 1) {
// 			return '';
// 		}

// 		// ascending
// 		if(SortBy[0] == fieldName) {
// 			return 'icon-asc';
// 		}

// 		// descending
// 		if(SortBy[0] == '-' + fieldName) {
// 			return 'icon-dsc';
// 		}

// 		// not found
// 		return '';

// 	}

// 	/**
// 	 *    ADD PAGING
// 	 *    used by controllers to add paging functionality
// 	 */

// 	function addPaging(vm) {
// 		vm.pagingAdvance = pagingAdvance;
// 		vm.pagingTo = pagingTo;
// 		vm.pagingPages = pagingPages;
// 		vm.rowCount = rowCount;
// 		vm.getTotalPages = getTotalPages;
// 	}

// 	function getTotalPages(rows, pageSize) {

// 		// return ui paging VM with re-calcuated total pages

// 		if(isNaN(pageSize) || pageSize < 1 || isNaN(rows)) {
// 			throw 'util.pagingCalculate, pageSize must be > 0 and rows must be a number';
// 		}

// 		// calculate total pages
// 		var total = 1;

// 		if(rows > pageSize) {
// 			total = Math.floor(rows / pageSize);
// 			if(rows % pageSize > 0) {
// 				total += 1;
// 			}
// 		}

// 		return total;

// 	}

// 	function pagingAdvance(move, Paging) {

// 		// paging move must a number
// 		if(isNaN(move)) {
// 			throw 'util.pagingAdvance, move must be a number';
// 		}

// 		var newPage = Paging.Page + move;

// 		// out of range
// 		if(newPage < 1 || newPage > Paging.Total) {
// 			return;
// 		}

// 		// move is ok
// 		Paging.Page = newPage;

// 	}

// 	function pagingTo(pageNum, Paging) {

// 		// page num must a number
// 		if(isNaN(pageNum)) {
// 			throw 'util.pagingAdvance, move must be a number';
// 		}

// 		// same page or out of range
// 		if(pageNum == Paging.Page || pageNum < 1 || pageNum > Paging.Total) {
// 			return;
// 		}

// 		// new page is ok
// 		Paging.Page = pageNum;

// 	}

// 	function pagingPages(pages) {

// 		// returns an array for ng-repeat to iterate over

// 		var items = [];

// 		if(isNaN(pages) || pages - 1 < 0) {
// 			return items;
// 		}

// 		// create array of pages
// 		items = new Array(pages);
// 		for(ipage = 1; ipage < pages; ipage++) {
// 			items[ipage - 1] = ipage.toString();
// 		}

// 		return items;

// 	}

// 	function rowCount(pageSize, itemLen) {

// 		// return the view rows based on item count or page size
// 		// note: return 0 if both are not available

// 		if(isNaN(pageSize) && isNaN(itemLen)) {
// 			return 0;
// 		}

// 		if(isNaN(pageSize) || pageSize == itemLen) {
// 			return itemLen;
// 		}

// 		if(isNaN(itemLen)) {
// 			return pageSize;
// 		}

// 		if(itemLen < pageSize) {
// 			return itemLen;
// 		}

// 		return pageSize;

// 	}

// 	/**
// 	 *    ADD FILTERING
// 	 *    add methods for advanced filters
// 	 */

// 	function addFiltering(vm) {
// 		vm.initFilters = initFilters;
// 		vm.resetFilters = resetFilters;
// 		vm.filterList = filterList;
// 	}

// 	function initFilters(setup) {

// 		var result = {
// 			Ready: false,
// 			Busy: false,
// 			Dirty: false,
// 			Dates: {},
// 			Numbers: {},
// 			Text: {},
// 			Exact: {},
// 			Count: 0,
// 			Config: {},
// 			SortBy: [],
// 			Page: 1,
// 			PageSize: 50,
// 			PageTotal: 1
// 		};

// 		// setup props defined
// 		if(!!setup) {
// 			for (var propName in setup) {
// 				if (setup.hasOwnProperty(propName)) {
// 					result[propName] = setup[propName];
// 				}
// 			}
// 		}

// 		return result;

// 	}

// 	function resetFilters(flt, keepPaging) {
// 		flt.Ready = false;
// 		flt.Dirty = false;
// 		flt.Busy = false;

// 		if(!!!keepPaging) {
// 			flt.Page = 1;
// 			flt.PageTotal = 1;
// 		}

// 		return flt;
// 	}

// 	function filterList(dataItems, flt) {

// 		// filter dataItems using incoming filter object
// 		// note: 	this function has no concept of waiting or debouncing, it will run every time its called immediately
// 		// 			this is called on init or tab load, see filterChange() for UI debouncing/blocking/isBusy functionality

// 		flt = flt || {Text:{}};

// 		// params
// 		if(!Array.isArray(dataItems)) {
// 			flt.PageTotal = 1;
// 			flt.Page = 1;
// 			flt.Count = 0;
// 			return [];
// 		}

// 		// filter .Text
// 		var fTxt = flt.Text;
// 		for (var txtProp in fTxt) {
// 			if (fTxt.hasOwnProperty(txtProp) && fTxt[txtProp] === '') {
// 				fTxt[txtProp] = undefined; // zero out blank strings (ngFilter bug)
// 			}
// 		}
// 		var newItems = $filter('filter')(dataItems, flt.Text);

// 		// filter .Exact
// 		if(newItems.length > 0) {
// 			if(!!flt.Exact) {
// 				var ex = flt.Exact,
// 					fltObj = {};
// 				for (var propName in ex) {
// 					if (ex.hasOwnProperty(propName) && isText(ex[propName])) {

// 						// using "defineProperty" function to create the search property as an identifier:  obj.propName
// 						// note: angular filter won't find dynamically added string properties: obj['propName']
// 						fltObj = {};
// 						Object.defineProperty(fltObj, propName, {
// 							value: ex[propName].toString(),
// 							writable: true,
// 							enumerable:true,
// 							configurable: true
// 						});

// 						newItems = $filter('filter')(newItems, fltObj, true);
// 						if(newItems.length < 1) {
// 							break;
// 						}
// 					}
// 				}
// 			}
// 		}

// 		// filter .Numbers
// 		var nmName = '';
// 		var nmVal = 0.0;
// 		var nmOp = '';
// 		var nmComparator = function(item) {
// 			switch(nmOp) {
// 				case '>':
// 					return parseFloat(item[nmName]) > nmVal;
// 				case '<':
// 					return parseFloat(item[nmName]) < nmVal;
// 			}
// 		};

// 		if(newItems.length > 0) {
// 			if(!!flt.Numbers) {
// 				var nums = flt.Numbers,
// 					fltNum = {},
// 					numTxt = '',
// 					simpleFlt = true;

// 				for (var numPropName in nums) {
// 					if (nums.hasOwnProperty(numPropName) && isText(nums[numPropName])) {
// 						numTxt = nums[numPropName].toString();
// 						simpleFlt = true;

// 						// has operators
// 						nmOp = numTxt[0];
// 						if(nmOp == '>' || nmOp == '<') {

// 							// nothing yet, don't filter
// 							if(numTxt.length < 2) {
// 								continue;
// 							}

// 							nmVal = parseFloat(numTxt.substr(1, numTxt.length));
// 							if(isNumber(nmVal)) {
// 								simpleFlt = false;
// 								nmName = numPropName;
// 								newItems = $filter('filter')(newItems, nmComparator);
// 							}
// 						}

// 						// use simple filter?
// 						if(simpleFlt) {
// 							// no operators, use simple filter
// 							var numFltObj = {};
// 							Object.defineProperty(numFltObj, numPropName, {
// 								value: numTxt,
// 								writable: true,
// 								enumerable:true,
// 								configurable: true
// 							});
// 							newItems = $filter('filter')(newItems, numFltObj);
// 						}

// 						if(newItems.length < 1) {
// 							break;
// 						}
// 					}
// 				}
// 			}
// 		}

// 		// filter .Dates
// 		if(newItems.length > 0 && Array.isArray(flt.Config.Dates) && flt.Config.Dates.length > 0) {
// 			newItems = $filter('filterDatesAsText')(newItems, flt.Dates, flt.Config.Dates, flt.Config.DateFmt);
// 		}

// 		// sort order
// 		if(newItems.length > 0) {
// 			newItems = $filter('orderBy')(newItems, flt.SortBy);
// 		}
// 		var filterCount = newItems.length;

// 		// paging
// 		flt.PageTotal = getTotalPages(newItems.length, flt.PageSize);
// 		if(isNumber(flt.Page) && flt.Page > 1) {

// 			// adjust page number on max after filtering
// 			if(flt.Page > flt.PageTotal) {
// 				flt.Page = flt.PageTotal;
// 			}

// 			// calculate page starting index
// 			var pageStart = ((flt.Page - 1) * flt.PageSize);
// 			if(pageStart < 0 || pageStart + 1 > newItems.length) {
// 				flt.Page = 1;
// 				pageStart = 0;
// 			}

// 			// cut out this page
// 			newItems = newItems.slice(pageStart, pageStart + flt.PageSize);

// 		}
// 		else {
// 			// reset paging
// 			flt.Page = 1;

// 			// show first page of rows
// 			if(newItems.length > 0 && newItems.length > flt.PageSize) {
// 				newItems = newItems.slice(0, flt.PageSize);
// 			}
// 		}

// 		// done filtering
// 		flt.Count = filterCount;

// 		return newItems;

// 	}

// 	/**
// 	 *    API RESULTS PAGING
// 	 *    converts api response into ui paging values
// 	 */

// 	function apiResultsPaging(paging, uiSize, itemNum, apiMax) {

// 		// server found too many results
// 		paging.TooMany = itemNum > apiMax;

// 		// set number of ui pages
// 		paging.Size = uiSize;
// 		if(itemNum > uiSize) {
// 			paging.Total = Math.floor(itemNum / uiSize);
// 			if(itemNum % uiSize > 0) {
// 				paging.Total += 1;
// 			}
// 		}

// 		return paging;

// 	}

/**
 *    HTTP SAFE RESPONSE
 *    safely build an invalid response object which will most likely serialize to JSON
 *    used to throw in error messages
 */

function httpSafeResponse(r: any): string {
    // response fix
    if (!!!r) {
        return 'undefined';
    }

    // status fix
    if (isNaN(r.status) || r.status < 0) {
        r.status = 'undefined';
    }

    // entity fix
    if (!!!r.Entity) {
        r.Entity = 'undefined';
    } else if (!Array.isArray(r.Entity)) {
        r.Entity = 'not an array';
    } else if (r.Entity.length > 10) {
        r.Entity = r.Entity.slice(0, 9); // remove excess items from Entity array
    }

    // paging fix
    if (!!!r.Paging) {
        r.Paging = 'undefined';
    }

    // attempt to serialize
    let safeResp = '';
    try {
        safeResp = JSON.stringify(r);
    } catch (err: any) {
        safeResp = 'cannot serialize response object: ' + err.message;
    }

    return safeResp;
}

function httpIgnore(r?: HttpErrorIgnore, handler?: string): HttpErrorIgnore {
    // if handling error return ignore to callers
    // note: handlers array keeps track of all methods ignoring error

    r = r || { ignore: true, handlers: [] };
    const hd = Array.isArray(r.handlers) ? r.handlers : [];
    if (handler && isText(handler)) {
        hd.push(handler);
    }

    return {
        ignore: true,
        handlers: hd,
    };
}

function httpIsIgnore(err?: HttpErrorIgnore): boolean {
    return !!!err || (!!err && err.ignore);
}

function apiContextToAllArray(val: string | undefined | null): string[] {
    if (!val || val === 'ALL') return [];
    return [val];
}

/**
 *    LOCATION: STATES
 */

function locStateNames(): TblFltOption[] {
    return [
        { val: 'AL', lbl: 'AL - Alabama' },
        { val: 'AK', lbl: 'AK - Alaska' },
        { val: 'AZ', lbl: 'AZ - Arizona' },
        { val: 'AR', lbl: 'AR - Arkansas' },
        { val: 'CA', lbl: 'CA - California' },
        { val: 'CO', lbl: 'CO - Colorado' },
        { val: 'CT', lbl: 'CT - Connecticut' },
        { val: 'DE', lbl: 'DE - Delaware' },
        { val: 'DC', lbl: 'DC - District Of Columbia' },
        { val: 'FL', lbl: 'FL - Florida' },
        { val: 'GA', lbl: 'GA - Georgia' },
        { val: 'HI', lbl: 'HI - Hawaii' },
        { val: 'ID', lbl: 'ID - Idaho' },
        { val: 'IL', lbl: 'IL - Illinois' },
        { val: 'IN', lbl: 'IN - Indiana' },
        { val: 'IA', lbl: 'IA - Iowa' },
        { val: 'KS', lbl: 'KS - Kansas' },
        { val: 'KY', lbl: 'KY - Kentucky' },
        { val: 'LA', lbl: 'LA - Louisiana' },
        { val: 'ME', lbl: 'ME - Maine' },
        { val: 'MD', lbl: 'MD - Maryland' },
        { val: 'MA', lbl: 'MA - Massachusetts' },
        { val: 'MI', lbl: 'MI - Michigan' },
        { val: 'MN', lbl: 'MN - Minnesota' },
        { val: 'MS', lbl: 'MS - Mississippi' },
        { val: 'MO', lbl: 'MO - Missouri' },
        { val: 'MT', lbl: 'MT - Montana' },
        { val: 'NE', lbl: 'NE - Nebraska' },
        { val: 'NV', lbl: 'NV - Nevada' },
        { val: 'NH', lbl: 'NH - New Hampshire' },
        { val: 'NJ', lbl: 'NJ - New Jersey' },
        { val: 'NM', lbl: 'NM - New Mexico' },
        { val: 'NY', lbl: 'NY - New York' },
        { val: 'NC', lbl: 'NC - North Carolina' },
        { val: 'ND', lbl: 'ND - North Dakota' },
        { val: 'OH', lbl: 'OH - Ohio' },
        { val: 'OK', lbl: 'OK - Oklahoma' },
        { val: 'OR', lbl: 'OR - Oregon' },
        { val: 'PA', lbl: 'PA - Pennsylvania' },
        { val: 'RI', lbl: 'RI - Rhode Island' },
        { val: 'SC', lbl: 'SC - South Carolina' },
        { val: 'SD', lbl: 'SD - South Dakota' },
        { val: 'TN', lbl: 'TN - Tennessee' },
        { val: 'TX', lbl: 'TX - Texas' },
        { val: 'UT', lbl: 'UT - Utah' },
        { val: 'VT', lbl: 'VT - Vermont' },
        { val: 'VA', lbl: 'VA - Virginia' },
        { val: 'WA', lbl: 'WA - Washington' },
        { val: 'WV', lbl: 'WV - West Virginia' },
        { val: 'WI', lbl: 'WI - Wisconsin' },
        { val: 'WY', lbl: 'WY - Wyoming' },
        { val: 'AS', lbl: 'AS - American Samoa' },
        { val: 'GU', lbl: 'GU - Guam' },
        { val: 'MP', lbl: 'MP - Northern Mariana Islands' },
        { val: 'PR', lbl: 'PR - Puerto Rico' },
        { val: 'VI', lbl: 'VI - Virgin Islands' },
        { val: 'TT', lbl: 'TT - Trust Territories' },
    ];
}

// 	function ngStateShortNamesDroplist() {

// 		return [
// 			{value:'AL', label:'AL'},
// 			{value:'AK', label:'AK'},
// 			{value:'AZ', label:'AZ'},
// 			{value:'AR', label:'AR'},
// 			{value:'CA', label:'CA'},
// 			{value:'CO', label:'CO'},
// 			{value:'CT', label:'CT'},
// 			{value:'DE', label:'DE'},
// 			{value:'DC', label:'DC'},
// 			{value:'FL', label:'FL'},
// 			{value:'GA', label:'GA'},
// 			{value:'HI', label:'HI'},
// 			{value:'ID', label:'ID'},
// 			{value:'IL', label:'IL'},
// 			{value:'IN', label:'IN'},
// 			{value:'IA', label:'IA'},
// 			{value:'KS', label:'KS'},
// 			{value:'KY', label:'KY'},
// 			{value:'LA', label:'LA'},
// 			{value:'ME', label:'ME'},
// 			{value:'MD', label:'MD'},
// 			{value:'MA', label:'MA'},
// 			{value:'MI', label:'MI'},
// 			{value:'MN', label:'MN'},
// 			{value:'MS', label:'MS'},
// 			{value:'MO', label:'MO'},
// 			{value:'MT', label:'MT'},
// 			{value:'NE', label:'NE'},
// 			{value:'NV', label:'NV'},
// 			{value:'NH', label:'NH'},
// 			{value:'NJ', label:'NJ'},
// 			{value:'NM', label:'NM'},
// 			{value:'NY', label:'NY'},
// 			{value:'NC', label:'NC'},
// 			{value:'ND', label:'ND'},
// 			{value:'OH', label:'OH'},
// 			{value:'OK', label:'OK'},
// 			{value:'OR', label:'OR'},
// 			{value:'PA', label:'PA'},
// 			{value:'RI', label:'RI'},
// 			{value:'SC', label:'SC'},
// 			{value:'SD', label:'SD'},
// 			{value:'TN', label:'TN'},
// 			{value:'TX', label:'TX'},
// 			{value:'UT', label:'UT'},
// 			{value:'VT', label:'VT'},
// 			{value:'VA', label:'VA'},
// 			{value:'WA', label:'WA'},
// 			{value:'WV', label:'WV'},
// 			{value:'WI', label:'WI'},
// 			{value:'WY', label:'WY'},
// 		];

// 	}

// 	/**
// 	 *    MONTH NAMES
// 	 */

type ModifiedDroplistItem = Omit<DroplistItem, 'value'> & { value: string | number };

function ngMonthShortDroplist(): ModifiedDroplistItem[] {
    return [
        { value: 1, label: 'Jan' },
        { value: 2, label: 'Feb' },
        { value: 3, label: 'Mar' },
        { value: 4, label: 'Apr' },
        { value: 5, label: 'May' },
        { value: 6, label: 'Jun' },
        { value: 7, label: 'Jul' },
        { value: 8, label: 'Aug' },
        { value: 9, label: 'Sep' },
        { value: 10, label: 'Oct' },
        { value: 11, label: 'Nov' },
        { value: 12, label: 'Dec' },
    ];
}

function ngMonthFullDroplist(): ModifiedDroplistItem[] {
    return [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];
}

// 	/**
// 	 *    VENDORS HARDCODED
// 	 *

// 	function vendorIdNameDroplist() {
// 		return [
// 			{value:"ABCSAFECOR", label: "Amerisource Safecor"},
// 			{value:"AMERISOURCE", label: "Amerisource Bergen"},
// 			{value:"CARDINAL", label: "Cardinal"},
// 			{value:"CARDINALSAFECOR", label: "Cardinal Safecor"},
// 			{value:"DAKOTADRUG", label: "Dakota Drug"},
// 			{value:"FFF", label: "FFF Enterprises"},
// 			{value:"HDSMITH", label: "HD Smith"},
// 			{value:"MCKESSON", label: "McKesson"},
// 			{value:"MCKESSONSAFECOR", label: "McKesson Safecor"},
// 			{value:"MORRISDICKSON", label: "Morris & Dickson"},
// 			{value:"MPB", label: "McKesson Plasma and Biologics"},
// 			{value:"NCMUTUAL", label: "NC Mutual"},
// 			{value:"ROCHESTER", label: "Rochester"},
// 			{value:"SMITH", label: "Smith Drugs"},
// 			{value:"VALUE", label: "Value Drug"}
// 		];
// 	}

// 	function vendorIdDroplist() {

// 		return [
// 			{value:"ABCSAFECOR", label: "ABCSAFECOR"},
// 			{value:"AMERISOURCE", label: "AMERISOURCE"},
// 			{value:"CARDINAL", label: "CARDINAL"},
// 			{value:"CARDINALSAFECOR", label: "CARDINALSAFECOR"},
// 			{value:"DAKOTADRUG", label: "DAKOTADRUG"},
// 			{value:"FFF", label: "FFF"},
// 			{value:"HDSMITH", label: "HDSMITH"},
// 			{value:"MCKESSON", label: "MCKESSON"},
// 			{value:"MCKESSONSAFECOR", label: "MCKESSONSAFECOR"},
// 			{value:"MORRISDICKSON", label: "MORRISDICKSON"},
// 			{value:"MPB", label: "MPB"},
// 			{value:"NCMUTUAL", label: "NCMUTUAL"},
// 			{value:"NONEDI", label: "NONEDI"},
// 			{value:"ROCHESTER", label: "ROCHESTER"},
// 			{value:"SMITH", label: "SMITH"},
// 			{value:"VALUE", label: "VALUE"}
// 		];

// 	}
// 	*/

// 	/**
// 	 *    CSS
// 	 */

// 	function cssButtonStyle(btnName) {

// 		// convert a button name into CSS style class

// 		switch(btnName) {

// 			case 'ONBOARDING':
// 				return 'btn-alt';

// 			case 'ACTIVE':
// 				return 'btn-alt';

// 			case 'INACTIVE':
// 				return 'btn-cancel';

// 			case 'CANCEL':
// 				return 'btn-cancel';

// 			case 'DELETE':
// 				return 'btn-delete';

// 			default:
// 				return '';

// 		}
// 	}

// 	function cssValidStyle(dirty, valid, fail) {

// 		// multiple validation status into 1 CSS icon

// 		if(!!valid && !!!fail) {
// 			// html rules valid and no server fail
// 			return 'icon-valid';
// 		}
// 		else if(!!dirty && !!!valid) {
// 			// user changed value and html rules invalid
// 			return 'icon-invalid';
// 		}
// 		else {
// 			return 'icon-width-0'; // any other case
// 		}

// 	}

// 	/**
// 	 *  JSON
// 	 *  uses angular json methods with error handling if 'safe' flag is true
// 	 */

// 	function jsonStringify(obj, safe) {

// 		// allows safe handling of possibly corrupt json objects
// 		// note: if safe flag is true, will always return a valid json string

// 		if(!!!safe) {
// 			return angular.toJson(obj);
// 		}
// 		else {
// 			try {
// 				return angular.toJson(obj);
// 			}
// 			catch(err) {
// 				return '{}';
// 			}
// 		}
// 	}

// 	function jsonStringifyPretty(obj, safe, indent) {

// 		// allows safe handling of possibly corrupt json objects
// 		// note: if safe flag is true, will always return a valid json string

// 		indent = isNaN(indent) ? 0 : indent;

// 		if(!!!safe) {
// 			return angular.toJson(obj, indent);
// 		}
// 		else {
// 			try {
// 				return angular.toJson(obj);
// 			}
// 			catch(err) {
// 				return '{}';
// 			}
// 		}
// 	}

// 	function jsonParse(txt, safe) {

// 		// allows safe handling of possibly corrupt json objects
// 		// note: if safe flag is true, will always return a valid json object

// 		if(!!!safe) {
// 			return angular.fromJson(txt);
// 		}
// 		else {
// 			try {
// 				return angular.fromJson(txt);
// 			}
// 			catch(err) {
// 				return {};
// 			}
// 		}
// 	}

// 	/**
// 	 *    REGEX
// 	 */

// 	function regexLogin() {
// 		// at least 1 number, 1 lower case, 1 upper case, length 6-12 characters
// 		return new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,12}$/);
// 	}

// 	function regexDateFmt(twoDigitYear) {
// 		if(!!twoDigitYear) {
// 			// MM/dd/yyyy or M/d/yyyy or two digit year "yy"
// 			return new RegExp(/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/\d{2,4}$/);
// 		}
// 		else {
// 			// MM/dd/yyyy or M/d/yyyy
// 			return new RegExp(/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/);
// 		}
// 	}

// 	function regexApiDateStringFmt() {
// 		// yyyy-MM-dd
// 		return new RegExp(/^(19|20)\d{2}\-(0?[1-9]|1[0-2])\-(0?[1-9]|1\d|2\d|3[01])$/);
// 	}

// 	function regexApiDateTimeStringFmt() {
// 		// yyyy-MM-dd-hh-mm-ss
// 		return new RegExp(/^(19|20)\d{2}\-(0?[1-9]|1[0-2])\-(0?[1-9]|1\d|2\d|3[01])\-(0?[0-9]|1[0-9]|2[0-3])\-(0?[0-9]|[0-5][0-9])\-(0?[0-9]|[0-5][0-9])$/);
// 	}

function regexFilename(nm): string {
    // strip all non-file path characters

    let cleanName = toText(nm);

    if (cleanName.length > 0) {
        cleanName = cleanName.replace(/[^A-Za-z0-9\.\-]+/g, '');

        if (cleanName.length > 250) {
            cleanName = cleanName.slice(-250); // cut from right to keep file extension
        }
    }

    return cleanName;
}

// 	function regexAlpha(txt) {

// 		// strip all non-file path characters

// 		var result = toText(txt);

// 		if(result.length > 0) {
// 			result = result.replace(/[^A-Za-z]+/g,'');
// 		}

// 		return result;

// 	}

// 	function regexDateISO(txt) {

// 		// matches the JSON ISO date string without evaluating the time values
// 		// example 0001-01-01T00:00:00Z

// 		return new RegExp(/^\d{4}-\d{2}-\d{2}T(.*)[Z]$/);
// 	}

// 	/**
// 	 *    OBJECT
// 	 */

// 	function objFindChildProp(obj, path) {

// 		/* recurse into object properties to get last property value in the path
// 		// example: use path = "child1.child2" to return the value of child2
// 		obj: {
// 			child1: {
// 				child2: value
// 			}
// 		}
// 		*/

// 		// path is valid?
// 		path = toText(path);
// 		if(!!!path) {
// 			return undefined;
// 		}

// 		// break path into an array of property names
// 		var props = path.split('.');

// 		// recurse to last child property
// 		var propVal = obj;
// 		for(var i = 0; i < props.length; i++) {
// 			if(!!propVal.hasOwnProperty(props[i])) {
// 				propVal = propVal[props[i]];
// 			}
// 			else {
// 				return undefined;
// 			}
// 		}

// 		// return last property value
// 		return propVal;

// 	}

/**
 *    AFFILIATES
 *    methods to query the affiliation matrix of all CE/RX/VEN combinations
 */

function affFindStatus(items: Affiliate[], status?: string[]): Affiliate[] {
    const result: Affiliate[] = [];
    status = Array.isArray(status) ? status : ['ONBOARDING', 'ACTIVE', 'INACTIVE'];

    for (let i = 0; i < items.length; i++) {
        if (status.indexOf(items[i].AffState) > -1) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindStatusOfCE(items: Affiliate[], ceid: string): string {
    const result: string = 'INACTIVE';

    for (let i = 0; i < items.length; i++) {
        if (items[i].CEID == ceid) {
            return items[i].CEStatus;
        }
    }

    return result;
}

function affFindCe(items: Affiliate[], ceid: string): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].CEID == ceid) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindCeList(items: Affiliate[], ceids: string[]): Affiliate[] {
    const result: Affiliate[] = [];

    if (!Array.isArray(ceids) || ceids.length < 1) {
        return result;
    }

    for (let i = 0; i < items.length; i++) {
        if (isText(items[i].CEID) && ceids.indexOf(items[i].CEID) > -1) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindRx(items: Affiliate[], rxid: string): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].RXID == rxid) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindRxList(items: Affiliate[], rxids: string[]): Affiliate[] {
    const result: Affiliate[] = [];

    if (!Array.isArray(rxids) || rxids.length < 1) {
        return result;
    }

    for (let i = 0; i < items.length; i++) {
        if (isText(items[i].RXID) && rxids.indexOf(items[i].RXID) > -1) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindTpa(items: Affiliate[], tpaid: string): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].ProgAdmin == tpaid) {
            result.push(items[i]);
        }
    }

    return result;
}

function rxShortNameById(items: Affiliate[], rxid: string): string {
    if (!isText(rxid)) {
        return '';
    }

    if (rxid == 'ALL') {
        return 'ALL';
    }

    for (let i = 0; i < items.length; i++) {
        if (items[i].RXID == rxid) {
            return items[i].RxShortName;
        }
    }

    return '';
}

// function ceNameById(items: Affiliate[], ceid: string): string {
//     if (!isText(ceid)) {
//         return '';
//     }

//     if (ceid == 'ALL') {
//         return 'ALL';
//     }

//     for (let i = 0; i < items.length; i++) {
//         if (items[i].CEID == ceid) {
//             return items[i].CeDisplayName;
//         }
//     }

//     return '';
// }

function affFindRxType(items: Affiliate[], rxtype: string[]): Affiliate[] {
    const result: Affiliate[] = [];
    rxtype = Array.isArray(rxtype) ? rxtype : ['DISPENSING', 'CENTRALFILL', 'ROLLUP'];

    for (let i = 0; i < items.length; i++) {
        if (rxtype.indexOf(items[i].RxType) > -1) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindRxModel(items: Affiliate[], rxmodels: string[]): Affiliate[] {
    const result: Affiliate[] = [];

    if (!Array.isArray(rxmodels) || rxmodels.length < 1) {
        return [];
    }

    for (let i = 0; i < items.length; i++) {
        if (rxmodels.indexOf(items[i].RxBizModel) > -1) {
            result.push(items[i]);
        }
    }

    return result;
}

function affFindRxBilling(items): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].Billing || items[i].VCentral) {
            result.push(items[i]);
        }
    }
    return result;
}

function affFindShareGroup(items: Affiliate[], grp: string): Affiliate[] {
    const result: Affiliate[] = [];

    if (isText(grp)) {
        for (let i = 0; i < items.length; i++) {
            for (let ii = 0; ii < items[i].AccumAllGroups.length; ii++) {
                if (items[i].AccumAllGroups[ii] == grp) {
                    result.push(items[i]);
                    break;
                }
            }
        }
    }

    return result;
}

function affFindVen(items: Affiliate[], venid: string, includeNoEDI: boolean): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        for (let ii = 0; ii < items[i].Ordering.length; ii++) {
            if (items[i].Ordering[ii].VENID == venid) {
                if (!!includeNoEDI || !!items[i].Ordering[ii].SupportsEDI) {
                    result.push(items[i]);
                }
                break;
            }
        }
    }

    return result;
}

function affWithVendor(items: Affiliate[], includeNoEDI: boolean): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (items[i].Ordering.length > 0) {
            if (!!includeNoEDI) {
                result.push(items[i]);
            } else {
                for (let ii = 0; ii < items[i].Ordering.length; ii++) {
                    if (!!items[i].Ordering[ii].SupportsEDI) {
                        result.push(items[i]);
                        break;
                    }
                }
            }
        }
    }

    return result;
}

function affFindVenType(items: Affiliate[], ventype: string[], includeNoEDI: boolean): Affiliate[] {
    const result: Affiliate[] = [];
    ventype = Array.isArray(ventype) ? ventype : ['340B'];

    let acct: AffiliateAccount;
    for (let i = 0; i < items.length; i++) {
        for (let ii = 0; ii < items[i].Ordering.length; ii++) {
            acct = items[i].Ordering[ii];
            if (ventype.indexOf(acct.Type) > -1) {
                if (!!includeNoEDI || !!acct.SupportsEDI) {
                    result.push(items[i]);
                }
                break;
            }
        }
    }

    return result;
}

// function affFindProgAdmin(items: Affiliate[], progAdmin: string): Affiliate[] {
//     const result: Affiliate[] = [];

//     for (let i = 0; i < items.length; i++) {
//         if (items[i].ProgAdmin == progAdmin) {
//             result.push(items[i]);
//         }
//     }

//     return result;
// }

function affFindVerityAdmin(items: Affiliate[]): Affiliate[] {
    const result: Affiliate[] = [];

    for (let i = 0; i < items.length; i++) {
        if (isText(items[i].ProgAdmin)) {
            continue;
        }
        result.push(items[i]);
    }

    return result;
}

function affRxList(items: Affiliate[]): string[] {
    const result: string[] = [];

    for (let i = 0; i < items.length; i++) {
        if (isText(items[i].RXID) && result.indexOf(items[i].RXID) < 0) {
            result.push(items[i].RXID);
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

function affRxDroplist(items: Affiliate[], ceid?: string, useNONE?: boolean, useALL?: boolean): DroplistItem[] {
    // get unique list of pharmacies, return them in droplist format

    const uniqueList: string[] = [];
    let shortName: string = '',
        result: DroplistItem[] = [];
    const hasCE: boolean = isText(ceid);

    // create a sorted list of unique rx short names in dropdown format
    for (let i = 0; i < items.length; i++) {
        if (!hasCE || (hasCE && items[i].CEID == ceid)) {
            shortName = items[i].RxShortName;
            if (isText(shortName) && uniqueList.indexOf(shortName) < 0) {
                uniqueList.push(shortName);
                result.push({ label: shortName, value: items[i].RXID });
            }
        }
    }
    result = sortTextAscending(result, 'label');

    if (!!useALL) {
        result.unshift({ label: 'All Pharmacies', value: 'ALL' });
    }

    useNONE = useNONE === false ? false : true; // default is true
    if (useNONE) {
        result.unshift({ label: 'Choose a Pharmacy', value: 'NONE' });
    }

    return result;
}

function affRxModelList(items: Affiliate[], includeNONE: boolean): string[] {
    const result: string[] = [];
    let bizModel: string = '';

    for (let i = 0; i < items.length; i++) {
        bizModel = isText(items[i].RxBizModel) ? items[i].RxBizModel : 'NONE';

        if (result.indexOf(bizModel) < 0) {
            if (bizModel != 'NONE' || !!includeNONE) {
                result.push(bizModel);
            }
        }
    }

    result.sort();

    return result;
}

function affRxModelsByFeature(feature: string): string[] {
    // convert a feature name into a list of RX business models

    switch (feature) {
        case 'ops.accum':
        case 'invoice.review':
            return ['CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

        case 'audit':
        case 'ops.ce.npi':
        case 'ops.rx.npi':
        case 'ops.catalogs.aff':
            return ['CPTPA', 'CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

        case 'ops.datamonitor':
        case 'ops.datamonitor.list':
            return ['NONE', 'CPTPA', 'CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

        case 'ops.transform':
            return ['SPLIT'];

        case 'ops.visits':
        case 'ops.match':
        case 'ops.claims':
            return ['CP', 'CPTPA', 'SPLITMATCH'];

        case 'orders.new.ce': // CE user can only create new splitting orders
        case 'invoice.split':
        case 'ops.splittrans':
            return ['SPLIT', 'SPLITMATCH'];

        case 'orders.list':
            return ['CP', 'SPLIT', 'SPLITMATCH'];

        case 'invoice.add':
            return ['NONE', 'CP', 'SPLIT', 'SPLITMATCH'];
        case 'invoice.cp':
            return ['CP'];

        case 'report.ce':
        case 'report.rx':
        case 'report.billing-rx': // Pharmacy Invoice
            return ['CP', 'CPSPLIT'];

        case 'report.splitsavings': // 340B Savings
            return ['SPLIT', 'SPLITMATCH'];

        case 'report.indigent':
        case 'report.unreplenished':
            return ['CP'];

        default:
            throw new Error('utilSvc.affRxFeatureModels, feature name not found: ' + feature);
    }
}

function affCeList(items: Affiliate[]): string[] {
    const result: string[] = [];

    for (let i = 0; i < items.length; i++) {
        if (isText(items[i].CEID) && result.indexOf(items[i].CEID) < 0) {
            result.push(items[i].CEID);
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

function affCeDroplist(items: Affiliate[], rxid?: string, useNONE?: boolean, useALL?: boolean): DroplistItem[] {
    // get unique list of covered entitites, return them in droplist format

    items = Array.isArray(items) ? items : [];

    let ceList: string[] = [],
        ceid: string = '';
    const result: DroplistItem[] = [];
    // RX specified?
    if (rxid && isText(rxid)) {
        ceList = affCeOptions(items, rxid);
    } else {
        ceList = affCeList(items);
    }
    useNONE = useNONE === false ? false : true; // default is true
    if (useNONE) {
        result.push({ label: 'Choose a Facility', value: 'NONE' });
    }
    if (!!useALL) {
        result.push({ label: 'All Covered Entities', value: 'ALL' });
    }

    for (let i = 0; i < ceList.length; i++) {
        ceid = ceList[i];
        result.push({ label: ceid, value: ceid });
    }

    return result;
}

function affCeDroplistLabel(
    items: Affiliate[],
    rxid?: string,
    useNONE?: boolean,
    useALL?: boolean,
    affilDisplayListPref?: string,
): DroplistItem[] {
    // get unique list of covered entitites, return them in droplist format

    items = Array.isArray(items) ? items : [];

    let ceList: string[] = [],
        ceid: string = '';
    const result: DroplistItem[] = [];

    // RX specified?
    if (isText(rxid)) {
        ceList = affCeOptions(items, <string>rxid);
    } else {
        ceList = affCeList(items);
    }

    useNONE = useNONE === false ? false : true; // default is true
    if (useNONE) {
        result.push({ label: 'Choose a Facility', value: 'NONE' });
    }
    console.log('usenonel', useNONE);

    if (!!useALL) {
        result.push({ label: 'All Covered Entities', value: 'ALL' });
    }

    for (let i = 0; i < ceList.length; i++) {
        ceid = ceList[i];
        for (let ii = 0; ii < items.length; ii++) {
            if (ceid == items[ii].CEID) {
                const display = affilDisplayListPref == 'USE_DISPLAY' ? items[ii].CeDisplayName : items[ii].CEID;
                result.push({ label: display, value: ceid });
                break;
            }
        }
    }
    return result;
}

function affShareGroupList(items: Affiliate[]): string[] {
    // sorted list of accumulator share groups

    const result: string[] = [];

    for (let i = 0; i < items.length; i++) {
        for (let ii = 0; ii < items[i].AccumAllGroups.length; ii++) {
            if (result.indexOf(items[i].AccumAllGroups[ii]) < 0) {
                result.push(items[i].AccumAllGroups[ii]);
            }
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

function affRxOptions(items: Affiliate[], ceid: string): string[] {
    // sorted list of all pharmacies affiliated with this CEID
    return affRxList(affFindCe(items, ceid));
}

function affRxOptionsByTPA(items: Affiliate[], tpaid: string): string[] {
    // sorted list of all pharmacies affiliated with this TPAID
    return affRxList(affFindTpa(items, tpaid));
}

function affCeOptions(items: Affiliate[], rxid: string): string[] {
    // sorted list of all covered entities affiliated with this RXID
    return affCeList(affFindRx(items, rxid));
}

function affVenOptions(
    items: Affiliate[],
    ceid: string,
    rxid: string,
    ventype?: string[],
    includeNoEDI?: boolean,
): string[] {
    // sorted list of vendors of 'ventype' with this CE/RX

    const result: string[] = [];
    ventype = Array.isArray(ventype) ? ventype : ['340B'];

    const affs = affFindRx(affFindCe(items, ceid), rxid);

    let acct: AffiliateAccount;
    for (let i = 0; i < affs.length; i++) {
        for (let ii = 0; ii < affs[i].Ordering.length; ii++) {
            acct = affs[i].Ordering[ii];
            if (ventype.indexOf(acct.Type) > -1 && result.indexOf(acct.VENID) < 0) {
                if (!!includeNoEDI || !!acct.SupportsEDI) {
                    result.push(acct.VENID);
                }
            }
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

function affAccumGrpAllOptions(items: Affiliate[], includeNoEDI: boolean): string[] {
    return affAccumGrpOptions(items, '', '', '', includeNoEDI, true);
}

function affAccumGrpOptions(
    items: Affiliate[],
    ceid: string,
    rxid: string,
    venid: string,
    includeNoEDI: boolean,
    useAllAffs?: boolean,
): string[] {
    // sorted list of account types with this CE/RX/VEN

    const result: string[] = [];

    const affs = !!useAllAffs ? items : affFindVen(affFindRx(affFindCe(items, ceid), rxid), venid, includeNoEDI);

    let acct: AffiliateAccount;
    for (let i = 0; i < affs.length; i++) {
        for (let ii = 0; ii < affs[i].Ordering.length; ii++) {
            acct = affs[i].Ordering[ii];
            if ((!!useAllAffs || acct.VENID == venid) && isText(acct.Type) && result.indexOf(acct.Type) < 0) {
                if (!!includeNoEDI || !!acct.SupportsEDI) {
                    result.push(acct.Type);
                }
            }
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

function affVenList(affs: Affiliate[], ventype?: string[], includeNoEDI?: boolean): string[] {
    // sorted list of vendors of 'ventype'

    const result: string[] = [];
    ventype = Array.isArray(ventype) ? ventype : ['340B'];

    let acct: AffiliateAccount;
    for (let i = 0; i < affs.length; i++) {
        for (let ii = 0; ii < affs[i].Ordering.length; ii++) {
            acct = affs[i].Ordering[ii];
            if (ventype.indexOf(acct.Type) > -1 && result.indexOf(acct.VENID) < 0) {
                if (!!includeNoEDI || !!acct.SupportsEDI) {
                    result.push(acct.VENID);
                }
            }
        }
    }

    // sort alpha asc
    result.sort();

    return result;
}

/* @ts-expect-error do-not-change */
function droplistByType(affs: Affiliate[], propType: string, limits: DroplistLimits): DroplistItem[] {
    // return an ng droplist from affiliations by one of types: CE, RX, VEN, ACCUMGRP

    if (!Array.isArray(affs) || affs.length < 1) {
        return [];
    }

    let affOptions: string[] = [],
        affPrompt: DroplistItem[] = [];

    switch (propType) {
        case 'CE':
            affOptions = !!limits ? affCeOptions(affs, <string>limits.RX) : affCeList(affs);
            affPrompt = [{ label: 'Choose a Facility', value: 'NONE' }];
            break;

        case 'RX':
            affOptions = !!limits ? affRxOptions(affs, <string>limits.CE) : affRxList(affs);
            affPrompt = [{ label: 'Choose a Pharmacy', value: 'NONE' }];
            break;

        case 'VEN':
            if (!!limits) {
                limits.ACCUMGRP = Array.isArray(limits.ACCUMGRP) ? limits.ACCUMGRP : ['340B', 'GPO', 'WAC'];
                affOptions = affVenOptions(
                    affs,
                    <string>limits.CE,
                    <string>limits.RX,
                    limits.ACCUMGRP,
                    <boolean>limits.includeNoEDI,
                );
            } else {
                affOptions = affVenList(affs, ['340B', 'GPO', 'WAC'], false);
            }
            affPrompt = [{ label: 'Choose a Vendor', value: 'NONE' }];
            break;

        case 'ACCUMGRP':
            affOptions = !!limits
                ? affAccumGrpOptions(
                      affs,
                      <string>limits.CE,
                      <string>limits.RX,
                      <string>limits.VEN,
                      <boolean>limits.includeNoEDI,
                  )
                : ['340B', 'GPO', 'WAC'];
            affPrompt = [{ label: ' ', value: 'NONE' }];
            break;

        default:
            throw new Error('utilSvc.droplistByType, unknown propType: ' + propType);
    }

    return ngDroplist(affOptions, '', '', affPrompt);
}

function tpaDroplist(items: { Name: string; Id: string }[]): DroplistItem[] {
    let result: DroplistItem[] = [];
    for (let i = 0; i < items.length; i++) {
        result.push({ label: items[i].Name, value: items[i].Id });
    }
    result = sortTextAscending(result, 'label');
    result.unshift({ label: 'Choose a Program Admin', value: 'NONE' });
    return result;
}

function affProgAdminList(items: Affiliate[]): Affiliate[] {
    const record: string[] = [];
    const result: Affiliate[] = [];

    for (var i = 0; i < items.length; i++) {
        const progAdmin = items[i]?.ProgAdmin;

        if (progAdmin !== undefined && isText(progAdmin) && record.indexOf(progAdmin) < 0) {
            result.push(items[i]);
            record.push(progAdmin);
        }
    }

    // sort alpha asc
    result.sort();
    return result;
}

function affProgramAdmin(items: Affiliate[]): string[] {
    const result: string[] = [];

    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.ProgAdmin !== undefined && item.ProgAdmin !== '' && result.indexOf(item.ProgAdmin) < 0) {
            result.push(item.ProgAdmin);
        }
    }

    return result;
}

// 	/**
// 	 *    MULTISELECT DROPDOWN
// 	 *    column filter control which uses a list of checkbox options or has a free-text filter textbox
// 	 */

// 	function addMultiselect(vm) {
// 		vm.multiselectBuild = multiselectBuild;
// 		vm.multiselectBuildWithLabel = multiselectBuildWithLabel;
// 		vm.multiselectBuildCE = multiselectBuildCE;
// 		vm.multiselectBuildRX = multiselectBuildRX;
// 		vm.multiselectClick = multiselectClick;
// 		vm.multiselectTitle = multiselectTitle;
// 		vm.multiselectReturnVisit = multiselectReturnVisit;
// 		vm.multiselectAllVals = multiselectAllVals;
// 	}

// 	function multiselectBuild(items, defaultState) {

// 		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false

// 		// don't add ALL if checklist has 1 other item to check
// 		if(items.length === 2 && items[0] == 'ALL') {
// 			return [{checked:defaultState, val: items[1], lbl: items[1]}];
// 		}
// 		else {
// 			var result = [];

// 			for(var i = 0; i < items.length; i++) {
// 				result.push({checked:defaultState, val: items[i], lbl: items[i]});
// 			}

// 			return result;
// 		}

// 	}

// 	function multiselectBuildWithLabel(items, defaultState,affs) {

// 		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false

// 		//dropListLabelItem Format //{label: display, lbl: display, value:ceid, val: ceid});

// 		// don't add ALL if checklist has 1 other item to check
// 		if(items.length === 2 && items[0] == 'ALL') {
// 			return [{checked:defaultState, val: items[1].val, lbl: items[1].lbl}];
// 		}
// 		else {
// 			var result = [];

// 			for(var i = 0; i < items.length; i++) {
// 				result.push({checked:defaultState, val: items[i].val, lbl: items[i].lbl});
// 			}

// 			return result;
// 		}
// 	}

// 	function multiselectBuildCE(items, defaultState,affs, useDisplay) {

// 		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false
// 		affs = Array.isArray(affs) ? affs : [];

// 		// don't add ALL if checklist has 1 other item to check
// 		if(items.length === 2 && items[0] == 'ALL') {
// 			if (useDisplay == "USE_DISPLAY") {
// 				return [{checked:defaultState, val: items[1], lbl: ceNameById(affs, items[1])}];
// 			} else {
// 				return [{checked:defaultState, val: items[1], lbl: items[1]}];
// 			}

// 		}
// 		else {
// 			var result = [];

// 			for(var i = 0; i < items.length; i++) {
// 				if (useDisplay == "USE_DISPLAY") {
// 					result.push({checked:defaultState, val: items[i], lbl: ceNameById(affs, items[i])});
// 				} else {
// 					result.push({checked:defaultState, val: items[i], lbl: items[i]});
// 				}
// 			}

// 			return result;
// 		}
// 	}

// 	function multiselectBuildRX(items, defaultState, affs) {

// 		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false
// 		affs = Array.isArray(affs) ? affs : [];

// 		// don't add ALL if checklist has 1 other item to check
// 		if(items.length === 2 && items[0] == 'ALL') {
// 			return [{checked:defaultState, val: items[1], lbl: rxShortNameById(affs, items[1])}];
// 		}
// 		else {
// 			var result = [];

// 			for(var i = 0; i < items.length; i++) {
// 				result.push({checked:defaultState, val: items[i], lbl: rxShortNameById(affs, items[i])});
// 			}

// 			return result;
// 		}

// 	}

// 	function multiselectClick(multiselect, val) {

// 		// OPTIONS item click

// 		// params
// 		var checkList = multiselect.list;

// 		// checklist is empty
// 		if(checkList.length < 1) {
// 			multiselect.vals = [];
// 			return;
// 		}

// 		// ALL click?
// 		var isAll = val == 'ALL',
// 			isClear = val == '|CLEAR|',
// 			usingALL = checkList[0].val == 'ALL',
// 			allStatus = false;

// 		// toggle ALL to true
// 		if(isAll && (!usingALL || (usingALL && !checkList[0].checked))) {
// 			allStatus = true;
// 		}

// 		// build filter values from checkbox status of each item
// 		var vals = [],
// 			i = usingALL ? 1 : 0;
// 		for(i; i < checkList.length; i++) {

// 			if(isClear) {
// 				checkList[i].checked = false;
// 			}
// 			else if(isAll) {
// 				// set all items based on ALL status
// 				checkList[i].checked = allStatus;
// 			}
// 			else if(checkList[i].val == val) {
// 				// toggle list item
// 				checkList[i].checked = !checkList[i].checked;
// 			}

// 			if(checkList[i].checked) {
// 				vals.push(checkList[i].val);
// 			}

// 		}

// 		// if user clicks all options, change to ALL mode
// 		if(usingALL) {
// 			if(vals.length === checkList.length - 1) {
// 				vals = ['ALL'];
// 				checkList[0].checked = true;
// 			}
// 			else {
// 				checkList[0].checked = false;
// 			}
// 		}

// 		multiselect.vals = vals;

// 	}

// 	function multiselectTitle(multiselect, autoSelectTitle) {

// 		// build title text and dirty shading

// 		var noneTitle = isText(multiselect.titleNoOptions) ? multiselect.titleNoOptions : 'No Options',
// 			allTitle = isText(multiselect.titleAllOptions) ? multiselect.titleAllOptions : 'All Options';

// 		switch(multiselect.focus) {
// 			case 'OPTIONS':
// 				if(multiselect.vals.length < 1) {
// 					multiselect.title = noneTitle;
// 				}
// 				else if(multiselect.vals.length === 1 && multiselect.vals[0] == 'ALL') {
// 					multiselect.title = allTitle;
// 				}
// 				else if(multiselect.vals.length === 1 && !!autoSelectTitle) {
// 					multiselect.title = multiselect.type == 'RX' ? multiselectRxName(multiselect.list, multiselect.vals[0]) : multiselect.vals[0];
// 				}
// 				else {
// 					multiselect.title = multiselect.vals.length.toString() + ' Options';
// 				}
// 				multiselect.dirty = (multiselect.vals.length === 1 && multiselect.vals[0] == 'ALL') ? false : true;
// 				break;
// 			case 'FIND':
// 				multiselect.title = 'Find: "' + (isText(multiselect.txtVal) ? multiselect.txtVal : '') + '"';
// 				multiselect.dirty = true;
// 				break;
// 			default:
// 				throw new Error('multiselectTitleBar, unknown focus: ' + multiselect.focus);
// 		}

// 	}

// 	function multiselectReturnVisit(multiselect, focus, vals, txt) {

// 		// restore multiselect from saved viewState

// 		// FIND uses ALL options
// 		if(focus == 'FIND') {
// 			vals = ['ALL'];
// 			txt = isText(txt) ? txt : '';
// 		}
// 		else {
// 			// OPTIONS uses empty text
// 			focus = 'OPTIONS';
// 			txt = '';
// 		}
// 		multiselect.focus = focus;

// 		// checklist is empty, exit
// 		var checkList = multiselect.list;
// 		if(!Array.isArray(checkList) || checkList.length < 1) {
// 			multiselect.list = [];
// 			multiselect.vals = [];
// 			multiselect.txtVal = '';
// 			return;
// 		}

// 		multiselect.vals = vals;
// 		multiselect.txtVal = txt;

// 		var isAll = vals.length === 1 && vals[0] == 'ALL',
// 			usingAll = checkList[0].val == 'ALL',
// 			isNone = vals.length < 1,
// 			i = 0;

// 		if(usingAll) {
// 			i = 1;
// 			checkList[0].checked = isAll;
// 		}

// 		for(i; i < checkList.length; i++) {
// 			if(isAll) {
// 				checkList[i].checked = true;
// 			}
// 			else if(isNone) {
// 				checkList[i].checked = false;
// 			}
// 			else {
// 				checkList[i].checked = vals.indexOf(checkList[i].val) > -1;
// 			}
// 		}

// 	}

// 	function multiselectRxName(chk, rxid) {

// 		// get RX Short Name from multi checklist items

// 		if(!Array.isArray(chk) || chk.length < 1 || !isText(rxid)) {
// 			return '';
// 		}

// 		for(var i = 0; i < chk.length; i++) {
// 			if(chk[i].val == rxid) {
// 				return chk[i].lbl;
// 			}
// 		}

// 		return rxid;
// 	}

// 	function multiselectAllVals(multiselect) {

// 		// return current vals, if ALL chosen then create vals from checklist options

// 		var result = [],
// 			checkList = multiselect.list,
// 			vals = multiselect.vals;

// 		// checklist or vals are empty
// 		if(checkList.length < 1 || vals.length < 1) {
// 			return result;
// 		}

// 		// vals exist but ALL not chosen
// 		var isAll = vals[0] == 'ALL';
// 		if(!isAll) {
// 			return vals;
// 		}

// 		// ALL chosen, create vals from checklist options
// 		var i = checkList[0].val == 'ALL' ? 1 : 0;  // skip ALL if first checklist option
// 		for(i; i < checkList.length; i++) {
// 			result.push(checkList[i].val);
// 		}

// 		return result;

// 	}

// 	/**
// 	 *    FLEX QUERY TOP
// 	 *    note: also supports max-height animation tbd...
// 	 */

// 	function addFlexTop(vm) {
// 		vm.flexInit = flexInit;
// 		vm.flexToggle = flexToggle;
// 		vm.flexCollapse = flexCollapse;
// 	}

// 	function flexInit() {
// 		return {
// 			ready: false,
// 			pending: false,
// 			state: 'body',
// 			showHead: false,
// 			showBody: true
// 		};
// 	}

// 	function flexToggle(flx, mouseState, queryOk) {

// 		// toggle between head / body
// 		// several conditions need to exist to collapse from body down to head
// 		if(mouseState == 'leave' && !!queryOk) {
// 			if(flx.state == 'head') {
// 				flx.pending = false;
// 			}
// 			else {
// 				flx.pending = true;
// 				flx.state = 'head';
// 			}
// 		}
// 		else {
// 			flx = flexInit();
// 		}

// 		return flx;
// 	}

// 	function flexCollapse(flx, forceClose) {

// 		// after a delay, is everything still ok to collapse?
// 		if(!!forceClose || (!!flx.pending && flx.state == 'head')) {
// 			flx.state = 'head';
// 			flx.showBody = false;
// 			flx.showHead = true;
// 			flx.pending = false;
// 		}

// 		return flx;
// 	}

/**
 *    USER
 */

function userHasFeature(userInfo: UserInfo | null, featName: string): boolean {
    // find feature claim in User features list
    if (userInfo && Array.isArray(userInfo.Features)) {
        const feats = userInfo.Features;
        for (let i = 0; i < feats.length; i++) {
            if (feats[i].Name == featName) {
                return true;
            }
        }
    }

    return false;
}

function userParseLoginProfile(usr: LoginResponse): UserPreferences {
    // parse for user preferences from login response

    const result: UserPreferences = {
        Dashboard: {},
        FilterSwap: {},
        TableViews: [],
        SavedReports: [],
        AdminPrefs: {},
    };

    // profile empty
    if (!!!usr || !Array.isArray(usr.Profile) || usr.Profile.length < 1) {
        return result;
    }

    try {
        const prefs: { Type: string; Value?: string }[] = usr.Profile;
        let prefVal: string | undefined = '';

        // loop prefs
        // note: login returns preferences in an array with each pref as stringified json: User.Profile[{Type:'DASHBOARD',Value:'...'}]
        for (let i = 0; i < prefs.length; i++) {
            prefVal = prefs[i].Value;
            if (!isText(prefVal)) {
                continue;
            }

            switch (prefs[i].Type) {
                case 'DASHBOARD':
                    // CE, RX, row properties must exist
                    let dash = JSON.parse(<string>prefVal);
                    if (
                        !!!dash ||
                        typeof dash.CE !== 'string' ||
                        typeof dash.RX !== 'string' ||
                        !Array.isArray(dash.rows) ||
                        !Array.isArray(dash.rxBizModels)
                    ) {
                        dash = {};
                    }
                    result.Dashboard = dash;
                    break;

                case 'FILTERSWAP':
                    const filterSwap = JSON.parse(<string>prefVal);
                    if (!!filterSwap) {
                        result.FilterSwap = filterSwap;
                    }
                    break;

                case 'TABLEVIEW':
                    const tblViews = JSON.parse(<string>prefVal);
                    if (Array.isArray(tblViews)) {
                        result.TableViews = tblViews;
                    }
                    break;

                case 'SAVEDREPORTS':
                    const series = JSON.parse(<string>prefVal);
                    if (Array.isArray(series)) {
                        result.SavedReports = series;
                    }
                    break;

                case 'ADMIN':
                    const adminPrefs = JSON.parse(<string>prefVal);
                    if (!!adminPrefs) {
                        result.AdminPrefs = adminPrefs;
                    }
                    break;

                default:
                    console.log('utilSvc.userParseLoginProfile, unknown user pref type: ' + prefs[i].Type);
            }
        }
    } catch (err) {
        return {
            Dashboard: {},
            FilterSwap: {},
            TableViews: [],
            SavedReports: [],
            AdminPrefs: {},
        };
    }

    return result;
}

// 	/**
// 	 *    TABLE VIEWS
// 	 */

// 	function addTableViews(vm) {
// 		vm.tblViewInit = tblViewInit;
// 		vm.tblViewReset = tblViewReset;
// 		vm.tblViewLoad = tblViewLoad;
// 		vm.tblViewSyncFilter = tblViewSyncFilter;
// 	}

// 	function tblViewVM() {

// 		return {
// 			current: '1', // default
// 			views: [],
// 			sections: [],
// 			show:{},
// 			sortby: [],
// 			pgsize: 50
// 		};

// 	}

// 	function tblViewReset(tblView, fullReset) {

// 		var result = tblViewVM();

// 		// keep views
// 		if(!!!fullReset) {
// 			result.views = tblView.views;
// 		}

// 		return result;

// 	}

// 	function tblViewInit(tblConfig, tvSaved) {

// 		// initialize default and saved table views
// 		// note: uses table config to validate columns are available for this user

// 		var result = tblViewVM();

// 		// setup default
// 		var defaultTable = {
// 			id: '1',
// 			title: 'Default',
// 			sortby: tblConfig.sortby,
// 			pgsize: tblConfig.pgsize,
// 			cols:'|'
// 		};

// 		// build default view columns (deliminated bar list format)
// 		var configCols = tblConfig.cols,
// 			configKeys = tblConfig.colKeys,
// 			colKey = {},
// 			i = 0;
// 		for(i = 0; i < configCols.length; i++) {
// 			colKey = configKeys[configCols[i]];
// 			if(colKey.default !== false) {
// 				defaultTable.cols += colKey.name + '|';
// 			}
// 		}
// 		result.views.push(defaultTable);

// 		// user has saved views?
// 		if(!!tvSaved) {

// 			var views = tvSaved.views,
// 				viewCols = [],
// 				viewOk = true;
// 			for(var v = 0; v < views.length; v++) {
// 				viewOk = true;
// 				viewCols = views[v].cols.split('|');

// 				// check the cols against config allowed cols
// 				for(var vv = 0; vv < viewCols.length; vv++) {
// 					if(isText(viewCols[vv]) && !!!configKeys[viewCols[vv]]) {
// 						// column not allowed, custom view is bad
// 						viewOk = false;
// 						break;
// 					}
// 				}
// 				if(viewOk) {
// 					result.views.push(views[v]);

// 					// is this view the default?
// 					if(tvSaved.current == views[v].id) {
// 						result.current = tvSaved.current;
// 					}
// 				}
// 				else {
// 					// task: remove this view from saved views
// 				}
// 			}
// 		}

// 		return result;

// 	}

// 	function tblViewFindCurrent(tblView) {

// 		// return current view reference

// 		var views = tblView.views;
// 		if(!isText(tblView.current) || !Array.isArray(views) || views.length < 1) {
// 			return null;
// 		}

// 		for(var i = 0; i < views.length; i++) {
// 			if(tblView.current == views[i].id) {
// 				return views[i];
// 			}
// 		}

// 		return null;

// 	}

// 	function tblViewLoad(tblConfig, tblView) {

// 		// features call load to display html table headers and col show/hide, pgsize, sortby

// 		// params
// 		if(!!!tblView || !isText(tblView.current) || !Array.isArray(tblView.views) || tblView.views.length < 1) {
// 			alert('loadTableView, Table views are empty');
// 			return;
// 		}

// 		var views = tblView.views,
// 			viewNow = tblViewFindCurrent(tblView);

// 		// use default if not found
// 		if(!!!viewNow) {
// 			tblView.current = '1';
// 			viewNow = views[0];
// 		}

// 		// load view details
// 		tblView.sortby = [viewNow.sortby];
// 		tblView.pgsize = viewNow.pgsize;

// 		// load view columns
// 		tblView.sections = [];
// 		tblView.show = {};
// 		var cols = viewNow.cols.split('|'),
// 			colName = '',
// 			sections = '|',
// 			section = '';

// 		for(var c = 0; c < cols.length; c++) {
// 			colName = cols[c];
// 			if(isText(colName) && !!tblConfig.colKeys[colName]) {
// 				tblView.show[colName] = true;

// 				// add section to list
// 				section = tblConfig.colKeys[colName].section;
// 				if(sections.indexOf('|' + section + '|') < 0) {
// 					sections += section + '|';

// 					tblView.sections.push({
// 						name: section,
// 						title: tblConfig.sections[section].title,
// 						cols: 1
// 					});
// 				}
// 				else {
// 					// section exists, increment column count
// 					tblView.sections[tblView.sections.length - 1].cols++;
// 				}
// 			}
// 		}

// 		return tblView;

// 	}

// 	function tblViewSyncFilter(tblConfig, tblView, flt, fltKeepPaging) {

// 		// remove any property from the filter the view isn't using

// 		var configCols = tblConfig.cols,
// 			configKeys = tblConfig.colKeys,
// 			col = {},
// 			currentView = tblViewFindCurrent(tblView);
// 		var viewCols = currentView.cols,
// 			fltRemove = {};

// 		for(var i = 0; i < configCols.length; i++) {
// 			col = configCols[i];
// 			if(viewCols.indexOf('|' + col + '|') < 0) {
// 				// exists in filter?
// 				if(!!flt[configKeys[col].flt]) {
// 					flt[configKeys[col].flt][col] = undefined;
// 				}
// 			}
// 		}

// 		// replace flt sort if not found in new view columns
// 		if(!!!fltKeepPaging || !Array.isArray(flt.SortBy) || flt.SortBy.length !== 1 || viewCols.indexOf('|' + flt.SortBy[0] + '|') < 0) {
// 			flt.SortBy = tblView.sortby;
// 		}

// 		// replace flt paging if flt value not valid
// 		if(!!!fltKeepPaging || !isNumber(flt.PageSize)) {
// 			flt.PageSize = tblView.pgsize;
// 		}

// 		return flt;
// 	}

// 	/**
// 	 *    HELPERS
// 	 */

// 	function widDateRangeList(removeOptions) {

// 		// generate list of date range options
// 		// note:
// 		//		see the directive "widget-input-date-range" for the full list as below
// 		//		an error will be thrown if these ever get out of sync
// 		var dateOptions = [
// 			{label:'', value: 'NONE'},
// 			{label:'Today', value: 'TODAY'},
// 			{label:'Yesterday', value: 'YESTERDAY'},
// 			{label:'Today & Yesterday', value: 'TODAYYESTERDAY'},
// 			{label:'Last 2 Days including Today', value: '2DAYS'},
// 			{label:'Last 3 Days including Today', value: '3DAYS'},
// 			{label:'Last 7 Days including Today', value: '7DAYS'},
// 			{label:'Last 2 Weeks', value: '2WEEKS'},
// 			{label:'Monthly', value: 'MONTHLY'},
// 			{label:'Month To Date', value: 'MTD'},
// 			{label:'Quarterly', value: 'QTR'},
// 			{label:'Quarter To Date', value: 'QTD'},
// 			{label:'Last Quarter', value: 'QTDLAST'},
// 			{label:'Custom Date Range (92 day max)', value: 'CUSTOM92'}
// 		];

// 		// remove options (caller can remove some of the date options, feature specific)
// 		if(Array.isArray(removeOptions)) {
// 			for(var i = dateOptions.length - 1; i >= 0; i--) {
// 				if(removeOptions.indexOf(dateOptions[i].value) > -1) {
// 					dateOptions.splice(i, 1);
// 				}
// 			}
// 		}

// 		return dateOptions;

// 	}

// 	function isNumber(val) {
// 		return !isNaN(val) && val !== null && val !== '';
// 	}

// 	function numberFmt(val, zeroFmt, prefix, decPlaces) {
// 		if (!isNumber(val)) {
// 			return '';
// 		}

// 		// zero
// 		if (val === 0) {
// 			return zeroFmt;
// 		}

// 		result = prefix + toText($filter('number')(val, decPlaces));
// 		return result;
// 	}
// }

export default utilSvc;
